import { ComponentType } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { parse } from 'querystring';
import { isNotNullish } from '@app/helpers/predicate';
import SeamlessSection from './SeamlessSection';
import {
  getIntlValidLocale,
  getLocaleFromPathname,
} from '../../../helpers/locale';
import SeamlessElementsQuery from './SeamlessElementQuery';
import {
  SeamlessElementsQueryVariables as QueryVariables,
  SeamlessElementsQuery_seamlessSection_elements,
  SeamlessElementsQuery_seamlessSection,
} from './__generated__/SeamlessElementsQuery';

interface InputProps extends RouteComponentProps {
  category: string;
}

interface QueryResult {
  loading: boolean;
  seamlessSection: SeamlessElementsQuery_seamlessSection;
}

export interface SeamlessSectionProps {
  loading: boolean;
  elements: SeamlessElementsQuery_seamlessSection_elements[] | null;
}

export default compose(
  withRouter,
  graphql<InputProps, QueryResult, QueryVariables, SeamlessSectionProps>(
    SeamlessElementsQuery,
    {
      options: ({ category, location }) => {
        const { previewToken } = parse(location.search?.substring(1));
        const language =
          location && location.pathname
            ? getIntlValidLocale(getLocaleFromPathname(location.pathname))
            : 'en';

        return {
          variables: {
            category,
            language,
            previewToken:
              typeof previewToken === 'string' ? previewToken : undefined,
          },
        };
      },
      props: ({ data }) => {
        const { loading, seamlessSection } = data as QueryResult;
        return {
          loading,
          elements: seamlessSection?.elements.filter(isNotNullish),
        };
      },
    }
  )
)(SeamlessSection) as ComponentType<{ category: string }>;
